import { useMemo } from "react";
import DefaultGridLayout, { WidthProvider } from "react-grid-layout";

import { SummaryLayoutItem } from "../../Models/SummaryLayoutItem";
import { MedicalSummarySections } from "./MedicalSummaryEnum";
import { SummaryDraggableItem } from "./SummaryDraggableItem";

import styles from "./SummaryArrangement.module.scss";

const ReactGridLayout = WidthProvider(DefaultGridLayout);

interface ISummaryArrangementProps {
    layout: SummaryLayoutItem[];
    setLayout: (layout: SummaryLayoutItem[]) => void;
    onVisibilityChange: (section: MedicalSummarySections) => void;
    isDraggable: boolean;
    isDisabled?: boolean;
}

function SummaryArrangement(props: ISummaryArrangementProps): JSX.Element {
    const { layout, isDraggable, isDisabled, onVisibilityChange, setLayout } = props;

    const style = isDisabled
        ? styles.summaryDisabledArrangement
        : isDraggable
            ? styles.summaryVisibleArrangement
            : styles.summaryHiddenArrangement;
    const children = useMemo(() => layout?.map(
        (item: SummaryLayoutItem) =>
            (
                <div
                    key={item.Section}
                    data-grid={SummaryLayoutItem.toReactGridLayoutItem(item)}
                    data-cy="summary-draggable-item"
                >
                    <SummaryDraggableItem
                        section={item.Section}
                        isHidden={item.IsHidden}
                        isDisabled={props.isDisabled}
                        onVisibilityChange={section => onVisibilityChange(section)}
                    />
                </div>
            )
    ), [layout, onVisibilityChange]);

    return (
        <ReactGridLayout
            isDraggable={isDraggable}
            isResizable={false}
            rowHeight={36}
            preventCollision={false}
            cols={2}
            layout={layout.map(p => SummaryLayoutItem.toReactGridLayoutItem(p))}
            onLayoutChange={layout => setLayout(layout.map((p, i) => SummaryLayoutItem.toSummaryLayoutItem(p, props.layout[i].IsHidden)))}
            className={`${styles.summaryArrangement} ${style}`}
        >
            {children}
        </ReactGridLayout>
    );
}

export { SummaryArrangement };
